import { render, staticRenderFns } from "./Banner005ObjetosCalidad.vue?vue&type=template&id=32983100"
import script from "./Banner005ObjetosCalidad.vue?vue&type=script&lang=js"
export * from "./Banner005ObjetosCalidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports